import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHelmetSafety } from '@fortawesome/free-solid-svg-icons/faHelmetSafety';
import type { IconProps } from '../../types';

export function HelmetSafetyIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Construction',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faHelmetSafety}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
